<template>
  <el-dialog
    class="rc-dialog"
    title="添加选调学员"
    :visible.sync="showTrainModal.flag"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="trainForm"
      ref="trainForm"
      >
      <el-row>
        <el-col :span="24">
          <el-form-item label="班级名称：" prop="classId">
            <load-select
              class="form-select"
              v-model="trainForm.classId"
              dictLabel="className"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getData"
              @ChangeValue="changeValue"
              placeholder="请选择选调班级（输入班级名称关键字以查询）"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="人选类型：" prop="superiorStatus">
            <el-select
              v-model="trainForm.superiorStatus"
              @change="changeTrainStatus"
              placeholder="请选择人选类型"
            >
              <el-option
                v-for="item in trainStatusData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getSuperiorTrainClass } from "@/api/class";
import LoadSelect from "@/components/load-select/index.vue";
import { getSysParamByTypes } from "@/api/sysParam";
import { saveTrainEnroll, validTrainEnroll } from "@/api/train";
export default {
  components: {
    LoadSelect,
  },
  props: {
    showTrainModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    selectUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      more: true,
      page: 1,
      data: [],
      trainForm: {
        classId: "",
        superiorStatus: ""
      },
      superiorStatusName: "",
      className: "",
      trainStatusData: [],
      rules: {
        superiorStatus: [{ required: true, message: "请选择人选类型" }],
        classId: [
          {
            required: true,
            message: "请选择班级",
            trigger: "blur, change",
          }
        ],
      },
    };
  },
  created() {
    this.getSysParamByTypes(["SUPERIOR_TRAIN_STATUS"]);
  },
  methods: {
    cancel() {
      this.$emit("closeTrainModal");
    },
    changeTrainStatus(val) {
      let selectObj = this.trainStatusData.find(function(item){
        return item.paramKey == val
      })
      this.superiorStatusName = selectObj.paramValue;
    },
    changeValue(val) {
      if (val) {
        let item = this.data.filter((item) => item.uuid == val)[0];
        this.className = item.className;
      } else return;
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.trainStatusData = res.data["SUPERIOR_TRAIN_STATUS"];
      });
    },
    getData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getSuperiorTrainClass({ page, className: keyword }).then(
          ({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.data = [...this.data, ...data];
            } else {
              this.data = data;
            }
            this.page = data.current;
            let { current, total, size } = data;
            this.more = current * size < total;
            this.page = current;
            resolve();
          }
        );
      });
    },
    submit() {
      if (!this.trainForm.classId) {
        this.$message({
          message: "请选择班级",
          type: "error"
        });
      } else if (!this.trainForm.superiorStatus) {
        this.$message({
          message: "请选择人选类型",
          type: "error"
        });
      } else {
        let params = {
          userIds: this.selectUsers.map((item) => item.userId)
        };
        validTrainEnroll(params.userIds).then((res) => {
          if (!res || res.code != 0) return;
          this.cancel();
          this.$confirm(`<p style="width: 100%; max-height: 250px; overflow-y: auto">${res.msg}</p>
          <p style="margin-top: 10px">确定添加选中人员作为${this.className}的${this.superiorStatusName}吗？</p>`, "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              this.saveTrainEnroll();
            }).catch(() => {});
        });
      }
    },
    saveTrainEnroll() {
      let users = [];
      this.selectUsers.forEach(ele => {
        users.push({ userId: ele.userId, userName: ele.userName});
      });
      let params = {
        ...this.trainForm,
        users: users
      };
      saveTrainEnroll(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    overflow: hidden;
    padding-bottom: 40px;
    .form-select {
      width: 80%;
    }
  }
}
</style>
